<template>
  <div class="demo-box">
    <TopNavigation :top-act="'7'"/>
    <div class="content" v-if="$store.state.webNavigator=='pc'">
      <div class="app-banner1 positionRE">
        <div class="app-banner1-bar">
          <div>
            <p class="app-banner1-tlt font44px">脂玫乐APP -专业健康瘦身</p>
            <p class="app-banner1-tip font26px">瘦身有计划 轻松不反弹</p>
          </div>
          <div>
            <div class="displayIB">
              <div class="app-banner1-ewm"></div>
            </div>
            <div class="displayIB app-banner1-right">
              <div class="app-banner1-bnt">
                <div class="iosIcon displayIB"></div>
                App Store
              </div>
              <div class="app-banner1-bnt">
                <div class="AndroidIcon displayIB"></div>
                Android
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="app-banner2 positionRE">
        <div class="app-banner2-bar positionAB">
          <p class="app-banner2-tlt font44px">健康评测</p>
          <p class="app-banner2-p font26px">
            根据用户的性别、身高、生日、 <br>
            体重、体重目标等数据，<br>
            提供每日所需热量、<br>
            目标体重建议以及健康评级。<br>
          </p>
        </div>
      </div>
      <div class="app-banner3">
        <div class="app-banner3-bar">
          <p class="app-banner3-tlt font44px">体脂秤</p>
          <p class="app-banner3-p font26px">
            为了帮助用户管理更多的身体数据，支持对接脂玫乐体脂秤设备。 <br>
            全面检测身体24项健康数据
          </p>
        </div>
        <div class="app-banner3-tzcBar">
          <div class="app-banner3-tzcLeft displayIB">
            <div class="app-banner3-LeftTop">
              <p class="app-banner3-tltTwo font26px">4项深度脂肪测量</p>
              <div v-for="(item , index) in banner3List" :key="index" class="displayIB app-banner3-item">
                <img title="" class="app-banner3-icon" :src="item.imgUrl" alt="">
                <p class="app-banner3-Name font17px">{{item.name}}</p>
              </div>
            </div>
            <div class="app-banner3-LeftBottom">
              <p class="app-banner3-tltTwo font26px">6项身体数据评估</p>
              <div v-for="(item , index) in banner3List2" :key="index" class="displayIB app-banner3-item">
                <img title="" class="app-banner3-icon" :src="item.imgUrl" alt="">
                <p class="app-banner3-Name font17px">{{item.name}}</p>
              </div>
            </div>
          </div>
          <div class="app-banner3-tzcRight displayIB">
            <p class="app-banner3-tltTwo font26px">14项重要身体数据</p>
            <div v-for="(item , index) in banner3List3" :key="index" class="displayIB app-banner3-item">
              <img title="" class="app-banner3-icon" :src="item.imgUrl" alt="">
              <p class="app-banner3-Name font17px">{{item.name}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="app-banner4 positionRE">
        <div>
          <p class="app-banner4-tlt font44px col33333">记录功能</p>
          <p class="app-banner4-text font26px col666666">身体数据记录、饮食记录、运动记录</p>
        </div>
        <div class="app-banner4-BgImg"></div>
      </div>
      <div class="app-banner5 positionRE">
        <div>
          <p class="app-banner5-tlt font44px col33333">跟踪指导</p>
          <p class="app-banner5-text font26px col666666">
            不止是简单的减肥健康工具 <br>
            专业团队将针对个体提供量身定制个性化瘦身方案和全程跟踪指导。
          </p>
        </div>
        <div class="app-banner5-BgImg"></div>
      </div>
      <div class="app-banner6">
        <p class="app-banner6-tlt font44px col33333">合作市场</p>
        <div class="app-banner6-bar">
          <div v-for="(item , index) in banner6List" :key="index" class="displayIB app-banner6-tip">
            <img title="" class="app-banner6-img" :src="item" alt="">
          </div>
        </div>
      </div>
    </div>
    <!--    手机-->
    <div v-else class="phone-page">
      <div class="phoneApp-banner positionRE">
        <div class="banner-TextBox">
          <p class="banner-tlt font46phone">脂玫乐APP -专业健康瘦身</p>
          <p class="banner-p font28phone">瘦身有计划 &nbsp;&nbsp;&nbsp;&nbsp; 轻松不反弹</p>
        </div>
        <div class="banner-ewmBox">
          <div class="banner-ewm"></div>
          <div class="banner-btnBox displayIB">
            <div class="banner-btn"><span class="banner-BtnIos"></span> App Store</div>
            <div class="banner-btn"><span class="banner-BtnAndroid"></span> Android</div>
          </div>
        </div>
        <div class="banner-fotImg positionAB"></div>
      </div>
      <div class="phoneApp-banner2 positionRE">
        <div class="banner2-TextBox">
          <p class="banner2-tlt font46phone">健康评测</p>
          <p class="banner2-p font28phone col666666">
            根据用户的性别、身高、生日、体重、体重目 <br>
            标等数据，提供每日所需热量、 <br>
            目标体重建议以及健康评级。 <br>
          </p>
        </div>
        <div class="banner2-img positionAB"></div>
      </div>
      <div class="phoneApp-banner3">
        <div class="banner3-textBox">
          <p class="banner2-tlt font46phone">体脂秤</p>
          <p class="banner2-p font28phone col666666">
            为了帮助用户管理更多的身体数据，支持对 <br>
            接脂玫乐体脂秤设备，全面检测身体24项健康数据。
          </p>
        </div>
        <div class="banner3-ListBox">
          <div class="banner3-List" v-for="(item , index) in phoneIconList" :key="index">
            <div class="banner3-ListTlt">{{item.tlt}}</div>
            <div class="banner3-iconList">
              <div class="banner3-icon displayIB positionRE" v-for="(item2 , index2) in item.list" :key="index2">
                <img title="" class="banner3-iconImg" :src="item2.imgUrl" alt="">
                <p class="banner3-iconP font15phone col666666 positionAB">{{item2.name}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="phoneApp-banner4 positionRE">
        <div class="banner4-textBox">
          <p class="banner4-tlt font46phone">记录功能</p>
          <p class="banner2-p font28phone col666666">
            身体数据记录、饮食记录、运动记录
          </p>
        </div>
        <div class="banner4-img positionAB"></div>
      </div>
      <div class="phoneApp-banner5 positionRE">
        <div class="banner5-textBox">
          <p class="banner4-tlt font46phone">跟踪指导</p>
          <p class="banner2-p font28phone col666666">
            不止是简单的减肥健康工具， <br>
            专业团队将针对个体提供量身定制个性化瘦身方案 <br>
            和全程跟踪指导。 <br>
          </p>
        </div>
        <div class="banner5-img positionAB"></div>
      </div>
      <div class="phoneApp-banner6">
        <div class="banner5-textBox">
          <p class="banner4-tlt font46phone">合作市场</p>
        </div>
        <div class="banner5-ListBox">
          <div class="banner5-Icon displayIB" v-for="(item , index) in banner5IconList" :key="index">
            <img title="" class="banner5-IconImg" :src="item" alt="">
          </div>
        </div>
      </div>
    </div>
    <FooterNavigation/>
  </div>
</template>
<script>
import TopNavigation from '../../components/TopNavigation/TopNavigation';
import FooterNavigation from '../../components/FooterNavigation/FooterNavigation';
import { myFun } from "../../plug/modifyImagePath"

export default {
  name: 'zmlapp',
  components: {TopNavigation, FooterNavigation, },
  title () {
    return {
      title: '脂玫乐APP|脂玫乐APP下载-脂玫乐',
      keywords: '脂玫乐下载，健康瘦身，减肥方法，脂玫乐APP，脂玫乐APP下载',
      description: '脂玫乐健康瘦身APP下载，扫码下载脂玫乐APP，健康评测，管理您的身体数据。',
    };
  },
  data () {
    return {
      banner3List: [
        {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip1.png'),
          name: '体脂率',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip2.png'),
          name: '内脏脂肪',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip3.png'),
          name: '皮下脂肪',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip4.png'),
          name: '脂肪重量',
        },
      ],
      banner3List2: [
        {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip5.png'),
          name: '身体年龄',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip6.png'),
          name: '标准体重',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip7.png'),
          name: '理想体重',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip8.png'),
          name: '身体评分',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip9.png'),
          name: '体重控制量',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip10.png'),
          name: '脂肪控制量',
        },
      ],
      banner3List3: [
        {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip11.png'),
          name: 'BMI',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip12.png'),
          name: '体重',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip13.png'),
          name: '去脂体重',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip14.png'),
          name: '肌肉率',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip15.png'),
          name: '基础代谢',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip16.png'),
          name: '燃脂心率',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip17.png'),
          name: '蛋白质率',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip18.png'),
          name: '水分率',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip19.png'),
          name: '骨骼肌率',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip20.png'),
          name: '肌肉重量',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip21.png'),
          name: '蛋白质重量',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip22.png'),
          name: '骨量',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip23.png'),
          name: '骨骼肌重量',
        }, {
          imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner3Tip24.png'),
          name: '水分重量',
        },
      ],
      banner6List: myFun([
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner6Tip1.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner6Tip2.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner6Tip3.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner6Tip4.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner6Tip5.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner6Tip6.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner6Tip7.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner6Tip8.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner6Tip9.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/zmlApp/banner6Tip10.png',
      ]),
      phoneIconList: [
        {
          tlt: '4项深度脂肪测量',
          list: [
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon01.png'),
              name: '体脂率',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon02.png'),
              name: '内脏脂肪',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon03.png'),
              name: '皮下脂肪',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon04.png'),
              name: '脂肪重量',
            },
          ],
        },
        {
          tlt: '6项身体数据评估',
          list: [
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon05.png'),
              name: '身体年龄',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon06.png'),
              name: '标准体重',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon07.png'),
              name: '理想体重',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon08.png'),
              name: '身体评分',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon09.png'),
              name: '体重控制量',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon10.png'),
              name: '脂肪控制量',
            },
          ],
        },
        {
          tlt: '14项重要身体数据',
          list: [
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon11.png'),
              name: 'BMI',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon12.png'),
              name: '体重',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon13.png'),
              name: '去脂体重',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon14.png'),
              name: '肌肉率',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon15.png'),
              name: '骨骼肌重量',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon16.png'),
              name: '基础代谢',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon17.png'),
              name: '燃脂心率',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon18.png'),
              name: '蛋白质率',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon19.png'),
              name: '水分率',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon20.png'),
              name: '水分重量',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon21.png'),
              name: '骨骼肌率',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon22.png'),
              name: '肌肉重量',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon23.png'),
              name: '蛋白质重量',
            },
            {
              imgUrl: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/icon24.png'),
              name: '骨量',
            },
          ],
        },
      ],
      banner5IconList: myFun([
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/iconList01.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/iconList02.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/iconList03.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/iconList04.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/iconList05.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/iconList06.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/iconList07.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/iconList08.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/iconList09.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/zmlAPP/iconList10.png',

      ]),
    };
  },
};

</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url("./zmlappPhone.less");
  }

  @media screen and (min-width: 800px) {
    @import url("./zmlapp.less");
  }
</style>



// WEBPACK FOOTER //
// zmlapp.vue